import { FunctionComponent } from "react";
import TaskActionRow from "../../components/actions/TaskActionRow";
import ActionLinks from "../../components/actions/ActionLinks";
import backArrow from "../../assets/task/back_arrow.svg";
import { useNavigate } from "react-router-dom";
import TodayMeetingsRow from "../../components/actions/TodayMeetingsRow";
import UpcomingMeetingsRow from "../../components/actions/UpcomingMeetingsRow";
import MyTodos from "../../components/actions/MyTodos";
import MigrationRow from "../../components/actions/MigrationRow";
import { useAuth } from "../../context/AuthContext";
import AssetLibraryRow from "../../components/actions/AssetLibraryRow";
import FeaturesAndDevRow from "../../components/actions/FeaturesAndDevRow";
// import dftarrowback from "../../assets/Admin/dftarrowback.svg"

const Actions: FunctionComponent = () => {
    const navigate = useNavigate()
    const { userInfo, logout } = useAuth()
    const employeeID = userInfo?.employee_id

    const allowedEmployeeIDs = ["1000103", "1000014"];

    function expandAskcary() {
        return (
            <ActionLinks />
        )
    }

    function renderActionRows() {
        return (
            <>
                <TodayMeetingsRow imageurl={""} heading="Today's Meetings" />
                <TaskActionRow imageurl={""} heading="Tasks" />
                <UpcomingMeetingsRow imageurl={""} heading="Upcoming Meetings" />
                <MyTodos imageurl={""} heading="My To Dos" />
                {/* {allowedEmployeeIDs?.includes(employeeID) && ( */}
                <MigrationRow imageurl={""} heading="Migration Tracker" />
                {/* )} */}
                {/* <FeatureTab heading="Feature History" /> */}
                <AssetLibraryRow imageurl={""} heading="Asset Library" />
                <FeaturesAndDevRow imageurl={""} heading="Features & Developers" />
            </>
        )
    }

    return (
        <div className="w-full relative overflow-hidden flex flex-col items-start justify-start min-w-[360px] max-w-[100%] leading-[normal] tracking-[normal] text-left text-xl text-colors-text-black font-body-xs-semi-bold mq450:max-w-full mq950:max-w-full mq1425:max-w-full mq1900:max-w-full">
            <div className="self-stretch bg-gray overflow-hidden flex flex-col items-center justify-start relative gap-[24px] min-h-[913px] max-w-full">
                <div id="cts-respon-p-dv" className="w-full flex flex-col items-start justify-start py-40 px-20  mq1490:px-[30px]  mq575:px-5 box-border gap-[24px] max-w-[100%] mq1425:max-w-full">
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] max-w-full">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate('/dashboard')}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">
                            Actions
                        </h3>
                    </div>
                    <div
                        className={`w-[100%] flex flex-col items-start justify-start gap-[20px] max-w-[100%] text-left text-xl text-colors-text-black font-body-xs-semi-bold mq1425:max-w-full action_main_cls_dv`}
                    >
                        <div className="self-stretch flex flex-row  items-start justify-start py-0 pr-0.5 pl-0 box-border gap-[20px_18px] max-w-full text-base tablet-view-blg-dv">
                            <div className="min-w-[70%] flex flex-col items-start justify-start gap-[20px]  max-w-full  mq575:min-w-full">{renderActionRows()}</div>
                            {expandAskcary()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Actions;
